<app-navbar title="Podsumowanie miesieczne">
	<button class="me-2" color="primary" mat-raised-button (click)="diet(SalaryBankExportKind.DIET)">
		<i class="fas fa-link"></i> Export Diet
	</button>
	<button class="me-2" color="primary" mat-raised-button (click)="diet(SalaryBankExportKind.MOBILITY_PACKAGE)">
		<i class="fas fa-link"></i> Export Pakiet mobilności
	</button>
	<button class="me-2" color="primary" mat-raised-button (click)="diet(SalaryBankExportKind.MOBILITY_PACKAGE_V2)">
		<i class="fas fa-link"></i> Export Pakiet mobilności V2
	</button>
</app-navbar>

<div class="m-2">
	<app-drivers-select-month (changeMonth)="setMonth($event)"> </app-drivers-select-month>
</div>

<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>

<app-drivers-salary-month-list-filters
	userFilters="driverSummaryList"
	[drivers]="parameters.drivers"
	[driverKinds]="parameters.driverKinds"
	[status]="parameters.status"
	[companies]="parameters.companies"
	[dietKinds]="parameters.dietKinds"
	[yesno]="parameters.yesno"
	(selected)="filtersSelected($event)"
>
</app-drivers-salary-month-list-filters>

<mat-table #dataTable [dataSource]="matData" matSort matSortDirection="asc" grouping="false">
	<ng-container *ngFor="let item of materialTable" [matColumnDef]="item.id">
		<mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ item.name }}
		</mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element[item.id] }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="action-button">
		<mat-header-cell *matHeaderCellDef></mat-header-cell>
		<mat-cell *matCellDef="let element">
			<a mat-raised-button color="primary" [routerLink]="'../' + element.id"> >> </a>
		</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="materialTableKeys"></mat-header-row>
	<mat-row
		*matRowDef="let row; columns: materialTableKeys"
		[ngClass]="{ 'is-confirm': row.confirmedDays === '1' }"
	></mat-row>
</mat-table>
@if (sum()) {
	<div class="card-body">
		<div class="form-inline text-start">
			<label class="me-4"> Podstawa: {{ sum().basicSalary.converted_pln }} PLN</label>
			<label class="me-4"> Diety: {{ sum().diets.converted_pln }} PLN</label>
			<label class="me-4"> Stawki: {{ sum().sumRates.converted_pln }} PLN</label>
			<label class="me-4"> Dodatki: {{ sum().sumBenefits.converted_pln }} PLN</label>
			<label class="me-4"> Potrącenia: {{ sum().sumDeduction.converted_pln }} PLN</label>
			<label class="me-4"> Przelew: {{ sum().transfer.converted_pln }} PLN</label>
			<label class="me-4"> Gotówka: {{ sum().cash.converted_pln }} PLN</label>
			<label class="me-4"> Miesięcznie: {{ sum().sumAll.converted_pln }} PLN</label>
			<label class="me-4"> Pozostało do wypłaty: {{ sum().leftToPay.converted_pln }} PLN</label>
			<label class="me-4"> Pakiet mobilności: {{ sum().mobilityPackage.converted_pln }} PLN</label>
		</div>
	</div>
}

<div class="modal fade" id="diet" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-lg modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="linkClose()"></button>
			</div>
			<div class="container">
				<div class="input-group mb-6">
					<label class="form-label"
						>Raport generuje się w
						<a
							href="https://docs.google.com/spreadsheets/d/1YFAelR1FeIgw8OdZaQ7abrFhvNsMbj_YPireL9z45Y4/edit#gid=0"
							>pliku</a
						>
					</label>
				</div>
			</div>
		</div>
	</div>
</div>
